'use client'

import { createContext, useContext, useState, useEffect, ReactNode } from 'react'
import { AppSession } from '@/lib/types'

interface AppContextType {
  session: AppSession | null
  setSession: (s: AppSession | null) => void
  logout: () => void
}

const AppContext = createContext<AppContextType | null>(null)

export function AppProvider({ children }: { children: ReactNode }) {
  const [session, setSessionState] = useState<AppSession | null>(null)

  useEffect(() => {
    const saved = localStorage.getItem('stoke_session')
    if (saved) {
      try { setSessionState(JSON.parse(saved)) } catch {}
    }
  }, [])

  function setSession(s: AppSession | null) {
    setSessionState(s)
    if (s) localStorage.setItem('stoke_session', JSON.stringify(s))
    else localStorage.removeItem('stoke_session')
  }

  function logout() {
    setSession(null)
  }

  return (
    <AppContext.Provider value={{ session, setSession, logout }}>
      {children}
    </AppContext.Provider>
  )
}

export function useApp() {
  const ctx = useContext(AppContext)
  if (!ctx) throw new Error('useApp must be used within AppProvider')
  return ctx
}
